// src/context/CartContext.jsx
import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const saved = localStorage.getItem("pg_cart");
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });

  // Persist to localStorage whenever cart changes
  useEffect(() => {
    localStorage.setItem("pg_cart", JSON.stringify(items));
  }, [items]);

  // Add game to cart (prevent duplicates)
  function addToCart(game) {
    setItems(prev => {
      if (prev.find(i => i.id === game.id)) return prev;
      return [...prev, { ...game, addedAt: Date.now() }];
    });
  }

  // Remove by id
  function removeFromCart(id) {
    setItems(prev => prev.filter(i => i.id !== id));
  }

  // Check if a game is already in cart
  function inCart(id) {
    return items.some(i => i.id === id);
  }

  // Clear entire cart
  function clearCart() {
    setItems([]);
  }

  const cartCount = items.length;
  const cartTotal = items.reduce((sum, i) => sum + (i.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, addToCart, removeFromCart, inCart, clearCart, cartCount, cartTotal }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside <CartProvider>");
  return ctx;
}